export const SITE_URL = "https://purba.lifesciencestudio.id";

// Sets <meta> / <link> attributes that already exist in public/index.html.
export const setHeadValue = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

export const getHeadValue = (selector, attribute) =>
  document.head.querySelector(selector)?.getAttribute(attribute) ?? null;
